
import { useState, useEffect } from "react";
import { fetchMessageThreads, type MessageThread } from "@/services/messages";
import { useAuth } from "@/contexts/auth";
import { createLogger } from "@/services/utils/loggingUtils";

const logger = createLogger('useMessageThreadsQuery');

export const useMessageThreadsQuery = () => {
  const [threads, setThreads] = useState<MessageThread[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { user } = useAuth();

  const fetchThreads = async () => {
    if (!user) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const fetchedThreads = await fetchMessageThreads();
      setThreads(fetchedThreads);
      setError(null);
    } catch (err) {
      logger.error('Error fetching message threads:', err);
      setError(err instanceof Error ? err : new Error('Failed to load message threads'));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchThreads();
  }, [user]);

  return {
    threads,
    isLoading,
    error,
    refetch: fetchThreads
  };
};
